import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Config } from 'shared/lib/config';
import {
  checkRefreshTokenAuth,
  redirectIfAccessRevoked,
} from 'shared/lib/authUtils';
import { refreshUserPermissions } from 'features/auth';
import Logger from 'shared/lib/logger';

export const BASE_URL = Config.REACT_APP_BACKEND_URL;

export const refreshToken = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await axios.post(
      `${BASE_URL}/refresh-token`,
      { token: checkRefreshTokenAuth() },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const newToken = response?.data?.data?.access_token;
    const newRefreshToken = response?.data?.data?.refresh_token;

    if (newToken && newRefreshToken) {
      const encryptTokenValue = CryptoJS.AES.encrypt(
        newToken,
        Config.REACT_APP_ENCRYPT_KEY_TOKEN
      ).toString();

      const encryptRefreshTokenValue = CryptoJS.AES.encrypt(
        newRefreshToken,
        Config.REACT_APP_ENCRYPT_KEY_REFRESH_TOKEN
      ).toString();

      localStorage.setItem('token', encryptTokenValue);
      localStorage.setItem('refresh_token', encryptRefreshTokenValue);

      // Re-pull /me so permissions stay current after a token refresh.
      // Fire-and-forget: the original 401-retried request must NOT wait on this.
      // A /me failure here is non-fatal — keep the existing permissions, log,
      // and do NOT log the user out.
      refreshUserPermissions()
        .then((menus) => redirectIfAccessRevoked(menus))
        .catch((permError) =>
          Logger.error('[refreshToken] /me refresh failed', {
            status: permError?.response?.status,
          })
        );

      return newToken;
    } else {
      throw new Error('No new token received');
    }
  } catch (err) {
    console.error('Error refreshing token:', err);
    throw err;
  }
};
